export default {
    map_geofence_geofencegroups: "Geofences",
    map_geofence_manage_geofence: "Manage Geofences",
    map_geofence_manage_visible: "Manage Visibility",
    map_geofence_manage_showAll: "Show All",
    map_geofence_manage_hiddenAll: "Hide All",
    map_geofence_geofenceList_invalid_geofence: "This geofence has incomplete data and cannot be edited.",
};